import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type WorkspaceOpportunityDetailsViewModel } from '@/features/opportunities/workspace-postings-opportunities/WorkspaceOpportunityDetailsViewModel'
import { WorkspaceOpportunityDetailsSheet } from '@/features/opportunities/workspace-postings-opportunities/components/WorkspaceOpportunityDetailsSheet'

export interface WorkspaceOpportunityDetailsSheetContainerProps {
  vm: WorkspaceOpportunityDetailsViewModel
  onClose?: () => void
}

export const WorkspaceOpportunityDetailsSheetContainer = observer(
  function WorkspaceOpportunityDetailsSheetContainer({
    vm,
    onClose,
  }: WorkspaceOpportunityDetailsSheetContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <WorkspaceOpportunityDetailsSheet
        opportunity={vm.selected?.details ?? null}
        onClose={onClose}
        isWithdrawPending={vm.withdraw.pending}
        onWithdraw={vm.withdraw}
        isApplyPending={vm.apply.pending}
        canApply={vm.selectedIsActive}
        onApply={vm.apply}
        corporateMode={shellInfo.corporateMode}
      />
    )
  },
)
